import React, {useContext} from "react";
import styled from "styled-components";
import {YourContributors} from "./YourContributors";
import NetworkSentiment from "./NetworkSentiment";
import MarketActivity from "./MarketActivity";
import {StockPageTitle} from "../StockPageTitle";
import StockChart from "./StockChart";
import {FeaturesContext} from "@timgroup/common-javascript-components";

const Container = styled.div`
    display: flex;
    padding-top: 30px;
    padding-right: 30px;
    padding-left: 30px;
`;

const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const TopRow = styled.div`
    display: flex;
    margin-bottom: 30px;
`;

const MiddleRow = styled.div`
    display: flex;
    margin-bottom: 12px;
`;

const Spacer = styled.div`
    width: 64px;
`;

const BottomRow = styled.div`
    display: flex;
    margin-top: 12px;
`;

const ChartContainer = styled.div`
    margin-left: 32px;
    flex-grow: 1;
`;

const StockData = ({stockDetails}) => {
    const features = useContext(FeaturesContext);

    return <Container>
        <DetailsContainer>
            <TopRow>
                <StockPageTitle bloomberg={stockDetails.bloomberg} name={stockDetails.name}/>
            </TopRow>
            <MiddleRow>
                <YourContributors longs={stockDetails.openIdeas.longs} shorts={stockDetails.openIdeas.shorts}/>
                <Spacer/>
                <NetworkSentiment sentiment={stockDetails.sentiment}/>
            </MiddleRow>
            <BottomRow>
                <MarketActivity stockDetails={stockDetails}/>
            </BottomRow>
        </DetailsContainer>
        <ChartContainer>
            <StockChart stockDetails={stockDetails}/>
        </ChartContainer>
    </Container>;
};

export default StockData;